import { END_POINTS } from '../helpers';
import { HorsePowerData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetHorsePowerResponse = {
  count: number;
  data: HorsePowerData[];
};

export const horsePowerApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getHorsePower: builder.query<
      CommonResponse & { data: GetHorsePowerResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getHorsePower}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteHorsePower: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteHorsePower}/${id}`,
        method: 'DELETE',
      }),
    }),
    getHorsePowerById: builder.query<CommonResponse & { data: HorsePowerData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getHorsePowerById}/${id}`,
        method: 'GET',
      }),
    }),

    addHorsePower: builder.mutation<
      CommonResponse & { data: HorsePowerData },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addHorsePower}`,
        method: 'POST',
        body,
      }),
    }),
    updateHorsePower: builder.mutation<
      CommonResponse & { data: HorsePowerData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateHorsePower}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddHorsePowerMutation,
  useUpdateHorsePowerMutation,
  useLazyGetHorsePowerQuery,
  useLazyDeleteHorsePowerQuery,
  useLazyGetHorsePowerByIdQuery,
} = horsePowerApi;
